import { useRef, useMemo } from "react";
import AdLogQueueService from "../../../../services/AdService/AdLogQueueService";

/**
 * Custom hook to manage video ad state, logging, and lifecycle
 */
export const useVideoAdManagement = ({ ads, deviceInfo }) => {
  console.log("🚀 ~ useVideoAdManagement ~ ads:", ads);
  const videoShownAtRef = useRef(null);
  const hasLoggedCurrentPlaybackRef = useRef(false);

  const videoAds = useMemo(() => {
    return (Array.isArray(ads) ? ads : []).filter(
      (ad) =>
        Number(ad?.mediaType) === 2 && // Must be video
        Number(ad?.adFormat) === 1 && // Must be FullScreen
        ad?.mediaPath,
    );
  }, [ads]);

  const imageAds = useMemo(
    () =>
      (Array.isArray(ads) ? ads : []).filter(
        (ad) => Number(ad?.mediaType) === 1 && ad?.mediaPath,
      ),
    [ads],
  );

  const logVideoAdImpression = async ({
    ad,
    shownAt,
    hiddenAt,
    playedSeconds,
    wasCompleted,
    wasSkipped,
  }) => {
    if (!ad?.id || !deviceInfo?.macId) return;

    const adLog = {
      adId: ad.id,
      macId: deviceInfo.macId,
      deviceName: deviceInfo.deviceName || "Unknown Device",
      adTitle: ad.title || "Unknown",
      adMediaPath: ad.mediaPath,
      ipAddress: deviceInfo.ipAddress || "0.0.0.0",
      shownAt: shownAt.toISOString(),
      hiddenAt: hiddenAt.toISOString(),
      visibleSeconds: playedSeconds,
      playedSeconds: playedSeconds,
      wasCompleted: Boolean(wasCompleted),
      wasSkipped: Boolean(wasSkipped),
      displayReason: 2, // Video display
      screenName: "Video",
      appVersion: "v1",
      durationSeconds: ad.durationSeconds || 0,
      timestamp: new Date().toISOString(),
    };

    AdLogQueueService.enqueue(adLog);
    console.log("📊 Logging ad impression:", adLog);
    // Try to log impression if AdLogService is available
    // try {
    //   // Dynamic import to avoid breaking if service doesn't exist
    //   const AdLogService = await import("../../../../services/AdService/AdLogService").then(
    //     (m) => m.default || m
    //   ).catch(() => null);

    //   if (AdLogService?.logAdImpression) {
    //     await AdLogService.logAdImpression(adLog);
    //     console.log(
    //       "✅ Ad log created successfully for:",
    //       ad.title,
    //       "- Completed:",
    //       wasCompleted,
    //       "- Skipped:",
    //       wasSkipped
    //     );
    //   } else {
    //     console.log("ℹ️ AdLogService not available, skipping ad logging");
    //   }
    // } catch (error) {
    //   console.error("❌ Failed to log ad impression:", error);
    // }
  };

  return {
    videoAds,
    imageAds,
    videoShownAtRef,
    hasLoggedCurrentPlaybackRef,
    logVideoAdImpression,
  };
};
